export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown) {
    super(`API_ERROR_${status}`);
    this.status = status;
    this.body = body;
  }
}

let authRevoked = false;

export function markClientAuthRevoked() {
  authRevoked = true;
}

export function clearClientAuthRevoked() {
  authRevoked = false;
}

function canBypassRevoked(path: string) {
  const p = String(path || '');
  return (
    p.startsWith('/api/public/') ||
    p === '/api/auth/login' ||
    p === '/api/auth/login-code' ||
    p === '/api/auth/check-email' ||
    p === '/api/auth/send-code' ||
    p === '/api/auth/register' ||
    p === '/api/auth/reset-password' ||
    p === '/api/auth/logout'
  );
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  if (authRevoked && !canBypassRevoked(path)) {
    throw new ApiError(401, { error: 'FORCED_LOGOUT' });
  }
  const hasBody = init?.body != null;
  const headers = new Headers(init?.headers || {});
  if (hasBody && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  const res = await fetch(path, {
    credentials: 'include',
    headers,
    ...init
  });

  const text = await res.text();
  const body = text ? safeJsonParse(text) : null;
  if (!res.ok) throw new ApiError(res.status, body);
  return body as T;
}

function safeJsonParse(text: string) {
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}
